// 099 D06 全站项目列表：跨用户只读，状态/行业/搜索过滤，行进项目详情
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ops } from "../../lib/api";
import { useOpsQuery } from "./useOpsQuery";
import { Note, StatusTag, fmtTime } from "./widgets";

const STATUS_OPTS = [
  { key: "", label: "全部状态" },
  { key: "done", label: "已完成" },
  { key: "running", label: "运行中" },
  { key: "failed", label: "失败" },
  { key: "canceled", label: "已取消" },
  { key: "needs_revision", label: "需修订" },
  { key: "none", label: "未生成" },
];

export default function Projects() {
  const nav = useNavigate();
  const [status, setStatus] = useState("");
  const [industry, setIndustry] = useState("");
  const [search, setSearch] = useState("");
  const [qInput, setQInput] = useState("");
  const [page, setPage] = useState(1);
  const q = useOpsQuery(
    () => ops.projects({ status, industry, q: search, page, pageSize: 50 }),
    [status, industry, search, page],
  );

  if (q.loading && !q.data) return <p className="muted">加载中…</p>;
  if (q.forbidden) return <p>🔒 {q.forbidden}</p>;
  if (q.error) return <p style={{ color: "var(--err)" }}>加载失败：{q.error}</p>;
  if (!q.data) return null;
  const d = q.data;
  const totalPages = Math.max(1, Math.ceil(d.total / d.pageSize));

  return (
    <>
      <h2 className="d-title">全站项目与内容查看</h2>
      <p className="d-sub2">跨用户只读 · 每次查看详情与下载均记录审计（D07/D11）</p>

      <div className="d-filter">
        <div className="d-chips">
          {STATUS_OPTS.map((o) => (
            <button key={o.key} className={`d-chip${status === o.key ? " on" : ""}`}
              onClick={() => { setStatus(o.key); setPage(1); }}>{o.label}</button>
          ))}
        </div>
        <span className="d-tz">
          行业：<select value={industry} onChange={(e) => { setIndustry(e.target.value); setPage(1); }}>
            <option value="">全部</option>
            {d.industries.map((i) => <option key={i} value={i}>{i}</option>)}
          </select>
        </span>
        <span className="d-updated">
          <input placeholder="搜索项目名…" value={qInput}
            onChange={(e) => setQInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { setSearch(qInput); setPage(1); } }} />
          <button className="d-chip" style={{ marginLeft: 8 }}
            onClick={() => { setSearch(qInput); setPage(1); }}>搜索</button>
        </span>
      </div>

      <div className="d-tblwrap">
        <table>
          <thead>
            <tr>
              <th>项目</th><th>所有者</th><th>行业</th><th>创建 / 更新</th><th>最新任务状态</th>
              <th className="num">任务数</th><th className="num">生成轮次</th><th>PPT</th><th></th>
            </tr>
          </thead>
          <tbody>
            {d.projects.map((p) => (
              <tr key={p.id} className="hoverable" onClick={() => nav(`/dashboard/projects/${p.id}`)}>
                <td><b>{p.name}</b><br /><span className="small muted">{p.id.slice(0, 8)}</span></td>
                <td>{p.ownerName ?? p.ownerEmail ?? p.ownerId.slice(0, 8)}{p.ownerName && p.ownerEmail ? <span className="small muted"><br />{p.ownerEmail}</span> : null}</td>
                <td>{p.industry ?? "—"}</td>
                <td className="small">{fmtTime(p.createdAt)}<br />{fmtTime(p.updatedAt)}</td>
                <td><StatusTag status={p.latestStatus} quality={p.latestQuality} degraded={p.latestDegraded} /></td>
                <td className="num">{p.jobsCount}</td>
                <td className="num"><b>{p.rounds} 轮</b>{p.rounds > 1 ? " 🚩" : ""}</td>
                <td>{p.hasPptx ? <span className="tag t-blue">{p.deckCount} 版</span> : <span className="muted">—</span>}</td>
                <td>›</td>
              </tr>
            ))}
            {!d.projects.length && <tr><td colSpan={9} className="muted">当前筛选无项目</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="d-filter" style={{ marginTop: 12, marginBottom: 0 }}>
        <span className="d-tz">共 {d.total} 个项目 · 第 {d.page}/{totalPages} 页</span>
        <span className="d-updated">
          <button className="d-chip" disabled={page <= 1} onClick={() => setPage(page - 1)}>← 上一页</button>{" "}
          <button className="d-chip" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>下一页 →</button>
        </span>
      </div>
      <Note>
        重新生成轮次作为质量信号展示（🚩 = 多轮），不增加项目数；retry 断点续跑不建行，故轮次不被自动重试抬高。
        内部评测/实验任务未做名称猜测剔除——如有内部项目请在命名上可辨识。
      </Note>
    </>
  );
}
